import { render, staticRenderFns } from "./Rodape.vue?vue&type=template&id=0fb299a7&scoped=true&"
var script = {}
import style0 from "./style.scss?vue&type=style&index=0&id=0fb299a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb299a7",
  null
  
)

export default component.exports